<template>
  <div>
    <div v-if="$vuetify.breakpoint.mdAndUp" class="floating-right" @click="setShowContactUsPanel()" @mouseleave="hoverContactUsPanel()" @focusout="hideShowContactUsPanel()" tabindex="0">
      <div @mouseenter="hoverContactUsPanel()" class="floating-button">{{ $t(`label.contactUs`) }}</div>
      <div v-if="showRewardPanel" class="contactUs-panel d-flex flex-column align-center justify-center">
        <div class="contactUs-header d-flex justify-space-around align-center">
          <div><img class="contactUs-header-icon" src="/static/svg/layout/customer-support.svg" alt="contactUs icon" /></div>
          <div>{{ $t(`floating.contactUsHeader`) }}</div>
        </div>
        <!--                <a href="https://direct.lc.chat/15594630/" rel="nofollow" target="_blank" class="contactUs-item livechat-item d-flex align-center">-->
        <!--                    <img class="contactUs-icon" :src="`/static/svg/layout/live-chat.svg`" alt="livechat support"/>-->
        <!--                    <div>{{ $t(`label.liveChat`) }}</div>-->
        <!--                </a>-->
        <a href="https://t.me/krikya88" rel="nofollow" class="contactUs-item telegram-item d-flex align-center">
          <img class="contactUs-icon" :src="`/static/svg/layout/telegram.svg`" alt="telegram support" />
          <div>krikya88</div>
        </a>
        <a href="mailto:support@krikya.com" rel="nofollow" target="_blank" class="contactUs-item email-item d-flex align-center">
          <img class="contactUs-icon" :src="`/static/svg/layout/email.svg`" alt="email support" />
          <div>support@krikya.com</div>
        </a>
        <a href="javascript:void(0);" @click="showIntercomLC" rel="nofollow" class="contactUs-item livechat-item d-flex align-center">
          <img class="contactUs-icon" :src="`/static/svg/layout/tr_livechat.svg`" alt="email support" />
          <div>{{ $t(`label.liveChat`) }}</div>
        </a>
      </div>
    </div>
    <!--    <div v-if="$vuetify.breakpoint.smAndDown" class="fab-contactUs">-->
    <!--      <div v-if="moreContactUs" class="d-flex flex-column">-->
    <!--        &lt;!&ndash;                <a href="https://direct.lc.chat/15594630/" rel="nofollow" target="_blank" class="mx-auto">&ndash;&gt;-->
    <!--        &lt;!&ndash;                    <img class="mobile-livechat-icon " src="/static/svg/layout/chat-mobile2.png" alt="livechat"/>&ndash;&gt;-->
    <!--        &lt;!&ndash;                </a>&ndash;&gt;-->
    <!--        <a href="https://t.me/krikya88" rel="nofollow">-->
    <!--          <img class="contactUs-icon" src="/static/svg/layout/telegram-mobile.svg" alt="telegram" />-->
    <!--        </a>-->
    <!--        <a href="mailto:support@krikya11.com" rel="nofollow" target="_blank">-->
    <!--          <img class="contactUs-icon" src="/static/svg/layout/email-mobile.svg" alt="email" />-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <div @click="setMoreContactUs()" class="contactUs-icon">-->
    <!--        <img class="contactUs-icon" :src="moreContactUs ? `/static/svg/layout/cancel-mobile.svg` : `/static/svg/layout/chat-mobile2.png`" alt="livechat support" />-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
import i18n from '@/plugins/i18n'
import { ROUTE_NAME } from '@/constants/route.constants'
import { DevicePlatform } from '@/constants/enums'

export default {
  name: 'floatingContactUs',
  props: {},
  data: () => ({
    i18n,
    showRewardPanel: false,
    active: false,
    moreContactUs: false
  }),
  methods: {
    showIntercomLC() {
      Intercom('show')
      return false
    },
    hoverContactUsPanel() {
      if (!this.active) this.showRewardPanel = !this.showRewardPanel
    },
    setShowContactUsPanel() {
      if (!this.active && this.showRewardPanel) {
        this.active = true
        this.showRewardPanel = true
      } else {
        this.active = !this.active
        this.showRewardPanel = !this.showRewardPanel
      }
    },
    hideShowContactUsPanel() {
      this.active = false
      this.showRewardPanel = false
    },
    setMoreContactUs() {
      this.moreContactUs = !this.moreContactUs
    },
    openLiveChat() {
      this.$parent.openLiveChat()
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  }
}
</script>

<style lang="scss">
.fab-contactUs {
  position: fixed;
  bottom: 90px;
  right: 20px;
  bottom: 9%;
  right: 3%;
  z-index: 5;
  text-decoration: none;

  .contactUs-icon {
    width: 72px;
    height: 72px;
    cursor: pointer;
  }

  .mobile-livechat-icon {
    width: 63px !important;
    height: 63px !important;
    cursor: pointer;
  }
}

.floating-right {
  position: fixed;
  display: flex;
  z-index: 5;
  right: 0;
  top: calc(50%);

  &:focus {
    &::after {
      width: 100%;
      height: 100%;
      display: absolute;
      z-index: 4;
      background-color: rgba(0, 0, 0, 0.65);
    }
  }

  .floating-button {
    //height: 230px;
    background-image: linear-gradient(to right, #f48020, #f05724);
    color: #ffffff;
    text-align: center;
    text-transform: uppercase;
    writing-mode: vertical-lr;
    text-orientation: mixed;
    transform: rotate(180deg);
    padding: 12px 8px;
    top: 0;
    cursor: pointer;
  }

  .contactUs-panel {
    background-color: #f5f5f5;

    .contactUs-header {
      font-size: 1em;
      max-width: 212px;
      text-align: center;
      padding: 0px 12px;

      .contactUs-header-icon {
        width: 80px;
        height: 80px;
      }
    }

    .contactUs-item {
      width: 100%;
      padding: 8px;
      gap: 8px;
      text-decoration: none;
      cursor: pointer;

      .contactUs-icon {
        width: 32px;
        height: 32px;
      }
    }

    .livechat-item {
      background-image: linear-gradient(#f48020, #f05724);
      color: #ffffff;
    }

    .telegram-item {
      background-image: linear-gradient(#45b4e4, #0092c8);
      color: #ffffff;
    }

    .email-item {
      background-image: linear-gradient(#70c59e, #368f6b);
      color: #ffffff;
    }
  }
}
</style>
